@if (
  {
    legalEntities: legalEntities$ | async,
    currentLegalEntity: currentLegalEntity$ | async,
    isMenuOpened: isMenuOpened$ | async,
    isOnColor: isOnColor$ | async,
  };
  as vm
) {
  <sg-button
    [matMenuTriggerFor]="menu"
    class="menu-toggle"
    #menuTrigger="matMenuTrigger"
    [class.opened]="vm.isMenuOpened"
    [variant]="vm.isOnColor ? 'ghost-secondary-on-color' : 'ghost-secondary'"
    [text]="vm.currentLegalEntity.displayName"
    icon="keyboard_arrow_down"
    iconPosition="end"></sg-button>
  <mat-menu #menu="matMenu" class="menu">
    <div class="menu-container">
      <button mat-menu-item (click)="cookiesSettings()">
        <mat-icon>sg-cookie</mat-icon>
        <span>Cookies Preferences</span>
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </button>
      @if (vm.legalEntities?.length > 1) {
        <mat-divider></mat-divider>
        <div class="swtich-account-title" disabled>Switch account to:</div>
        @for (le of vm.legalEntities; track le.id) {
          @if (vm.currentLegalEntity.id !== le.id) {
            <button class="legal-entity-item" (click)="selectLegalEntity(le)" mat-menu-item>{{ le.displayName }}</button>
          }
        }
      }
    </div>
  </mat-menu>
}
